import Vue from 'vue'
import App from './App.vue'
import ant from 'ant-design-vue'
import router from './router.js'
import MySelect from "./ui/MySelect";
import MyPage from "./ui/MyPage";
import MySelectTree from "./ui/MySelectTree";
import MyDate from "./ui/MyDate";
import MyDateTime from "./ui/MyDateTime";
import 'ant-design-vue/dist/antd.css'
import BaiduMap from "vue-baidu-map";
import moment from "moment";
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'dyxGpYwu8Gwj20CfPl6MK00AVXVXth1w'

});
Vue.use(ant);
Vue.component('my-select',MySelect);
Vue.component('my-page',MyPage);
Vue.component('my-select-tree',MySelectTree);
Vue.component('my-date',MyDate);
Vue.component('my-datetime',MyDateTime);
Vue.prototype.$moment = moment;
Vue.config.productionTip = false;
new Vue({
  el: '#app',
  render: h => h(App),
  router
}).$mount('#app');
